/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/prefer-optional-chain */
/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { isVue2 } from 'vue-demi';

/**
 * 以下 为vue3的类型，但是在vue3未导出，只能先复制过来
 */

/**
 * 以下 为vue3的类型，但是在vue2没有
 */

/**
 * vue3的DefineComponent
 * vue2.7与vue3 DefineComponent 参数个数不一致，以vue3为主。
 */

/**
 * 与defineComponent保持一致
 * overload 3: 有props的类型定义
 */

/**
 * overload 1: object format with no props
 */

/**
 * 针对 option-api component 的 vue2 兼容
 * @param comp - 组件 option 对象
 * @param options - 组件的配置项
 * @param options.model - 可选，vue2 组件的 model 选项，默认值：{ prop: 'value', event: 'update:value' }
 */
export function patchComponent(comp) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (isVue2) {
    if (options.model) {
      comp.model = options.model;
    }
    // 兼容 v-model
    if (comp.props && comp.props.value !== undefined && !comp.model) {
      const model = options.model || {
        prop: 'value',
        event: 'update:value'
      };
      comp.model = model;
    }
    // 兼容生命周期
    if (comp.beforeDestroy || comp.destroyed) {
      throw new Error('组件的生命周期 beforeDestroy/destroyed 应该变更为 beforeUnmount/unmounted');
    }
    if (comp.beforeUnmount) {
      comp.beforeDestroy = comp.beforeUnmount;
      // 不能删除，vue2 的 popover 组件读取不到： _popper.beforeUnmount
      // delete comp.beforeUnmount;
    }
    if (comp.unmounted) {
      comp.destroyed = comp.unmounted;
      // 暂时不删除，原因同上
      // delete comp.unmounted;
    }
  }
  return comp;
}